import { z } from 'zod';
import type { Layout } from '@kioskforge/shared';
import type { PresetDefinition } from './types';

const config_schema = z.object({ headline: z.string().min(1), media_id: z.string().min(1), duration_s: z.number().int().min(1).max(3600) });
const layout = {
  version: 1 as const, grid: { cols: 8, rows: 4 }, home: 'signage',
  screens: [{ id: 'signage', name: 'Welcome signage', blocks: [
    { id: 'headline', type: 'text' as const, rect: { x: 0, y: 0, w: 8, h: 1 }, props: { text: '{data.headline}', size: 'xl' as const, align: 'center' as const, weight: 'bold' as const } },
    { id: 'media', type: 'media' as const, rect: { x: 0, y: 1, w: 8, h: 3 }, props: { mode: 'playlist' as const, fit: 'cover' as const, items: [{ media_id: 'sample', kind: 'image' as const, duration_s: 30 }] } }
  ] }]
} satisfies Layout;

export const signage: PresetDefinition<typeof config_schema> = {
  key: 'signage', sector: 'Digital Signage', wave: 1, name: 'Welcome signage',
  min_lockdown: 'pwa', device_classes: ['tablet', 'esp32'], config_schema, layout
};